import { c as _c } from "react/compiler-runtime";
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Badge } from '@algoacademy/design-system/web/data-display/Badge';
import { H3 } from '@algoacademy/design-system/web/marketing/typography/Heading/H3';
import { P3 } from '@algoacademy/design-system/web/marketing/typography/Paragraph/P3';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
type AdvancedMentoringInfoProps = {
  mentoringProduct: AdvancedMentoringProductDTO;
};
export function AdvancedMentoringInfo(t0) {
  const $ = _c(26);
  const {
    mentoringProduct
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <P3 className="text-slate-600">Wybrana subskrypcja</P3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <H3>Mentoring rozszerzony</H3>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mentoringProduct.subscription) {
    t3 = <div className="flex flex-row flex-wrap items-center justify-between gap-2">{t2}<Badge className="bg-blue-100 px-2.5 py-0.5 font-semibold text-algoprimary text-sm">Subskrypcja co <span>{mentoringProduct.subscription}</span></Badge></div>;
    $[2] = mentoringProduct.subscription;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <P3 className="text-slate-600">Wszystko to, co w mentoringu podstawowym, a także: </P3>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== mentoringProduct.hoursWithMentor) {
    t5 = mentoringProduct.hoursWithMentor > 0 && <IconOnTheLeftWithContentLayout mainContent={<P3 className="text-slate-900"><span className="font-semibold">{mentoringProduct.hoursWithMentor} godz.</span>{" "}konsultacji w miesiącu</P3>} />;
    $[5] = mentoringProduct.hoursWithMentor;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== mentoringProduct.mentorReplyTime) {
    t6 = mentoringProduct.mentorReplyTime === "Priorytet odpowiedzi" ? "Mentor odpowie na Twoje pytania w pierwszej kolejno\u015Bci." : <>Maks. <span className="font-semibold">{mentoringProduct.mentorReplyTime} </span>czasu oczekiwania na odpowiedź mentora</>;
    $[7] = mentoringProduct.mentorReplyTime;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <IconOnTheLeftWithContentLayout mainContent={<P3 className="text-slate-900">{t6}</P3>} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== mentoringProduct.linesOfCode) {
    t8 = mentoringProduct.linesOfCode > 0 && <IconOnTheLeftWithContentLayout mainContent={<P3 className="text-slate-900"><span className="font-semibold">{mentoringProduct.linesOfCode} linii</span> Twojego kodu sprawdzi mentor</P3>} />;
    $[11] = mentoringProduct.linesOfCode;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== mentoringProduct.applicationHelp) {
    t9 = mentoringProduct.applicationHelp > 0 && <IconOnTheLeftWithContentLayout mainContent={<P3 className="font-semibold text-slate-900">Mentor pomoże Ci w wyszukiwaniu i aplikowaniu na prestiżowe programy i stypendia</P3>} />;
    $[13] = mentoringProduct.applicationHelp;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== mentoringProduct.careerCoaching) {
    t10 = mentoringProduct.careerCoaching > 0 && <IconOnTheLeftWithContentLayout mainContent={<P3 className="font-semibold text-slate-900">Mentor pomoże Ci w budowaniu marki osobistej, optymalizacji CV</P3>} />;
    $[15] = mentoringProduct.careerCoaching;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t11 = <div className="space-y-4">{t5}{t7}{t8}{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t3) {
    t12 = <section className="flex-1 space-y-2">{t1}{t3}{t4}{t11}</section>;
    $[23] = t11;
    $[24] = t3;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}